<glxy-page #page [pagePadding]="!page.pageMobile">
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button [useHistory]="true"></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>{{ 'INBOX.SETTINGS.MESSAGE_TEMPLATES.TITLE' | translate }}</glxy-page-title>
    <glxy-page-actions>
      <button mat-flat-button color="primary" (click)="redirectToCreateTemplate()">
        <span *ngIf="(showFullButton$ | async) === true">
          {{ 'INBOX.SETTINGS.MESSAGE_TEMPLATES.CREATE_TEMPLATE' | translate }}
        </span>
        <mat-icon *ngIf="(showFullButton$ | async) === false" class="icon-button">add</mat-icon>
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper widthPreset="narrow">
    <ng-container *ngIf="templates$ | async as templateList">
      <ng-container *ngIf="(loading$ | async) === false; else loadingTemplates">
        <mat-card>
          <mat-card-content *ngIf="templateList.length > 0; else emptyState">
            <mat-list>
              <ng-container *ngFor="let template of templateList; last as last">
                <mat-list-item [lines]="4" class="template-list-item">
                  <div class="template-content">
                    <div class="template-info">
                      <div matListItemTitle>{{ template.name }}</div>
                      <p matListItemLine>
                        {{ template.content }}
                      </p>
                    </div>
                    <div class="template-actions">
                      <button
                        mat-icon-button
                        data-testid="edit-template-button"
                        matTooltip="{{ 'INBOX.SETTINGS.MESSAGE_TEMPLATES.EDIT_TEMPLATE' | translate }}"
                        (click)="goToEditTemplate(template)"
                      >
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        data-testid="delete-template-button"
                        [disabled]="isDefaultTemplate(template.templateId)"
                        matTooltip="{{ 'INBOX.SETTINGS.MESSAGE_TEMPLATES.DELETE_TEMPLATE' | translate }}"
                        (click)="openDeleteConfirmationModal(template.templateId)"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </mat-list-item>
                <mat-divider *ngIf="!last"></mat-divider>
              </ng-container>
            </mat-list>
          </mat-card-content>
        </mat-card>
        <glxy-infinite-scroll-trigger
          (isVisible)="loadNext()"
          [visiblilityMargin]="0"
          [minHeight]="0"
        ></glxy-infinite-scroll-trigger>
      </ng-container>
    </ng-container>

    <ng-template #loadingTemplates>
      <glxy-loading-spinner></glxy-loading-spinner>
    </ng-template>
    <ng-template #emptyState>
      <glxy-empty-state [size]="'small'">
        <glxy-empty-state-hero>
          <mat-icon>article</mat-icon>
        </glxy-empty-state-hero>
        <glxy-empty-state-title>
          {{ 'INBOX.MESSAGE_TEMPLATES.MODAL.EMPTY_STATE_TITLE' | translate }}
        </glxy-empty-state-title>
        <p>{{ 'INBOX.MESSAGE_TEMPLATES.MODAL.EMPTY_STATE_CONTENT' | translate }}</p>
      </glxy-empty-state>
    </ng-template>
  </glxy-page-wrapper>
</glxy-page>
